import Tms from '@nicolaudie-group/translation-management-system'

import buildMode from '@nicolaudie-group/ng-ui-kit/helpers/buildMode'
import envFallback from '@nicolaudie-group/ng-ui-kit/helpers/envFallback'

import config from '@/config'

const tms = new Tms(
  config.clientUid,
  envFallback('dev', 'staging', 'production'),
  {
    verbose: buildMode.dev,
  },
)

const translate = (keyword, options) => tms.translate(keyword, options)

translate.setLanguage = (lang = 'en') => (
  new Promise((resolve, reject) => {
    tms.setLanguage(lang, (err) => {
      if (err) {
        return reject(err)
      }
      return resolve()
    })
  })
)

export default translate
